// ----- import from npm modules -----
import React from 'react';
import $, {get} from 'jquery';

// ----- import from base libraries -----

import {useEffect, useState, useRef} from 'react';

import enumList from 'web/utils/enumList';
import {useDispatch} from 'react-redux';
import {BaseComponent} from 'web/components/BaseComponent';
import {showMessage} from 'web/utils/modalHelper';
import {useEmployee} from '../hooks/useEmployee';

const EmployeePage = (props) => {
  const {
    onBatchHandle,
    needEmployeeLoad,
    setNeedEmployeeLoad,
    onDepartmentListModal,
    toggleEmployeeAddModal,
    toggleEmployeeEditModal,
    onPositionListModal,
    onDispatchListModal,
    needSearchLoad,
    onDepartmentSelection,
    onPositionSelection,
    departmentList,
    positionList,
  } = props;
  const dispatch = useDispatch();
  const baseComponent = new BaseComponent(props);
  const [searchEmployeeName, setSearchEmployeeName] = useState('');
  const [searchEmployeeCode, setSearchEmployeeCode] = useState('');
  const [searchPositionCode, setSearchPositionCode] = useState('');
  const [searchDepartmentCode, setSearchDepartmentCode] = useState('');
  const tableRef = useRef(null);

  const {employeeList, getEmployeeList, onBatch} = useEmployee(
    dispatch,
    baseComponent,
    showMessage,
    onBatchHandle,
    // onDepartmentSelection,
    // onPositionSelection,
  );

  useEffect(() => {
    getEmployeeList(
      searchEmployeeName,
      searchEmployeeCode,
      searchPositionCode,
      searchDepartmentCode,
    );
    setNeedEmployeeLoad(false);
  }, [needEmployeeLoad]);

  useEffect(() => {
    const handleClick = (event) => {
      const button = event.target.closest('.btn');
      if (button && button.id.startsWith('edit-employee-')) {
        const pureEmployee = JSON.parse(
          JSON.stringify(employeeList[button.id.split('-')[2]]),
        );
        toggleEmployeeEditModal(true, pureEmployee);
      }
      const checkbox = event.target.closest('input[type="checkbox"]');
      if (checkbox && checkbox.id.startsWith('eab-employee-')) {
        const index = parseInt(checkbox.id.split('-')[2]);
        const mode = checkbox.checked
          ? enumList.alertModalModeEnums.enable
          : enumList.alertModalModeEnums.disable;
        const updateEmployee = employeeList[index];
        if (updateEmployee) {
          let message = '';
          if (mode === enumList.alertModalModeEnums.enable) {
            message = `啟用 [ ${updateEmployee.employeeName} ] 的資料`;
          } else {
            message = `停用 [ ${updateEmployee.employeeName} ] 的資料`;
          }
          onBatchHandle(mode, enumList.targetAction.employee, message, [
            updateEmployee.employeeCode,
          ]);
        } else {
          console.log('No case found at index:', index);
        }
      }
    };

    if (tableRef.current) {
      tableRef.current.addEventListener('click', handleClick);
    }

    return () => {
      if (tableRef.current) {
        tableRef.current.removeEventListener('click', handleClick);
      }
    };
  }, [employeeList]);

  const handleSearch = (e) => {
    e.preventDefault();
    const searchForm = new FormData(e.target);
    let employeeName = searchForm.get('searchEmployeeName');
    const employeeCode = searchForm.get('searchEmployeeCode');
    let departmentCode = searchForm.get('searchDepartmentCode');
    let positionCode = searchForm.get('searchPositionCode');

    if (
      employeeName === '' &&
      employeeCode === '' &&
      departmentCode === '' &&
      positionCode === ''
    ) {
      showMessage(enumList.messageModalMode.error, '', '請輸入查詢條件');
      return;
    }
    if (employeeName === '0') {
      employeeName = '';
    }
    if (positionCode === '0') {
      positionCode = '';
    }
    if (departmentCode === '0') {
      departmentCode = '';
    }

    getEmployeeList(employeeName, employeeCode, positionCode, departmentCode);

    // resetSearch();
  };

  const resetSearch = () => {
    setSearchEmployeeName('');
    setSearchEmployeeCode('');
    setSearchPositionCode('');
    setSearchDepartmentCode('');
  };

  // const onNewEmployee = () => {
  //   toggleEmployeeAddModal();
  // };

  return (
    <section id="datatable-container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <svg
              className="nav__icon nav__icon--breadcrumb me-3"
              aria-hidden="true"
            >
              <use href="#ico-home-line"></use>
            </svg>
            基本資料
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            員工資料
          </li>
        </ol>
      </nav>
      <h4>員工資料</h4>
      <div className="datatable__search">
        <form
          className="d-flex gap-2 align-items-end needs-validation"
          noValidate
          onSubmit={handleSearch}
        >
          <div className="flex-fill w-100">
            <label htmlFor="searchEmployeeName" className="form-label">
              員工名稱
            </label>
            <input
              className="form-control form-control-sm"
              id="searchEmployeeName"
              name="searchEmployeeName"
              value={searchEmployeeName}
              onChange={(e) => setSearchEmployeeName(e.target.value)}
              required
            ></input>
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchEmployeeCode" className="form-label">
              員工編號
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="searchEmployeeCode"
              name="searchEmployeeCode"
              value={searchEmployeeCode}
              onChange={(e) => setSearchEmployeeCode(e.target.value)}
              required
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchPositionCode" className="form-label">
              職位
            </label>
            <select
              className="form-select form-select-sm"
              id="searchPositionCode"
              name="searchPositionCode"
              value={searchPositionCode}
              onChange={(e) => setSearchPositionCode(e.target.value)}
              required
            >
              <option disabled value="">
                請選擇
              </option>
              <option value="0">全部</option>
              {positionList &&
                positionList.map((position, index) => (
                  <option key={index} value={position.positionCode}>
                    {position.positionName}
                  </option>
                ))}
            </select>
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchDepartmentCode" className="form-label">
              部門列表
            </label>
            <select
              className="form-select form-select-sm"
              id="searchDepartmentCode"
              name="searchDepartmentCode"
              value={searchDepartmentCode}
              onChange={(e) => setSearchDepartmentCode(e.target.value)}
              required
            >
              <option disabled value="">
                請選擇
              </option>
              <option value="0">全部</option>
              {departmentList &&
                departmentList.map((department, index) => (
                  <option key={index} value={department.departmentCode}>
                    {department.departmentName}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <button className="btn btn-primary" type="submit">
              <svg className="btn__icon" aria-hidden="true">
                <use href="#ico-search"></use>
              </svg>
            </button>
          </div>
        </form>
      </div>
      <div className="datatable__tool">
        <div className="d-flex align-items-center gap-2">
          <div className="datatable__tool__label">
            多筆選擇
            <div id="checked-count-display"></div>
          </div>
          {baseComponent.checkPermission(
            enumList.moduleEnums.department,
            enumList.accessModeEnums.delete,
          ) && (
            <div className="btn-group btn-group-sm" role="group" aria-label="">
              <button
                type="button"
                className="btn btn-outline-secondary btn-batch"
                id="btnBatchEnable"
                onClick={() => onBatch(enumList.alertModalModeEnums.enable)}
              >
                啟用
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary btn-batch"
                id="btnBatchDisable"
                onClick={() => onBatch(enumList.alertModalModeEnums.disable)}
              >
                停用
              </button>
            </div>
          )}
        </div>

        <div className="d-flex align-items-center gap-2">
          {baseComponent.checkPermission(
            enumList.moduleEnums.condition,
            enumList.accessModeEnums.read,
          ) && (
            <>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={onDispatchListModal}
              >
                <svg className="btn__icon me-1" aria-hidden="true">
                  <use href="#ico-layers-three-02"></use>
                </svg>
                指派條件
              </button>
            </>
          )}

          {baseComponent.checkPermission(
            enumList.moduleEnums.position,
            enumList.accessModeEnums.read,
          ) && (
            <>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={onPositionListModal}
              >
                <svg className="btn__icon me-1" aria-hidden="true">
                  <use href="#ico-layers-three-02"></use>
                </svg>
                職位管理
              </button>
            </>
          )}
          {baseComponent.checkPermission(
            enumList.moduleEnums.department,
            enumList.accessModeEnums.read,
          ) && (
            <>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                id="modalElevatorBtnNew"
                onClick={onDepartmentListModal}
              >
                <svg className="btn__icon me-2" aria-hidden="true">
                  <use href="#ico-dataflow-01"></use>
                </svg>
                部門管理
              </button>
            </>
          )}
          {baseComponent.checkPermission(
            enumList.moduleEnums.employee,
            enumList.accessModeEnums.create,
          ) && (
            <>
              <button
                type="button"
                className="btn btn-sm btn-primary"
                id="modalElevatorBtnNew"
                onClick={() => {
                  toggleEmployeeAddModal();
                }}
              >
                <svg className="btn__icon me-2" aria-hidden="true">
                  <use href="#ico-plus-square"></use>
                </svg>
                新增
              </button>
            </>
          )}
        </div>
      </div>
      <div className="datatable__data" ref={tableRef}>
        <table
          id="datatable__elevatorList"
          className="display table table-hover align-middle nowrap"
        ></table>
      </div>
    </section>
  );
};

export default EmployeePage;
